import { PeriodoGetModelo111DtoProps } from "api/DTOs/PeriodoGetModelo111Dto"
import { MODELO_IMPUESTO } from "api/Types/ModeloImpuesto"
import { formatCurrency } from "common/utils/currency"
import { TFunction } from "i18next"
import * as ROUTES from "routes/RoutePaths"
import { TEXTO_TRIMESTRE } from "../../constants/textoTrimestre"
import { RedirectParams } from "../constants"

export const MODELO_111_COLUMNS = (
  t: TFunction,
  navigate: ({ route, periodo, modelo, year }: RedirectParams) => void,
  selectedYear: string
) => {
  const columns = [
    {
      header: `${t("taxSummary.tables.period")}`,
      field: "periodo",
      key: "periodo",
      style: { width: "20%" },
      body: ({ periodo }: PeriodoGetModelo111DtoProps) =>
        periodo ? TEXTO_TRIMESTRE(t)[periodo] : "Total",
    },
    {
      header: `${t("taxSummary.tables.totalPerceptors")}`,
      field: "importe",
      key: "importe",
      style: { width: "25%" },
      alignCol: "right",
      body: (rowData: PeriodoGetModelo111DtoProps) =>
        rowData?.totalPerceptores ?? 0,
      bodyClassName: "!tw-w-auto !tw-text-end",
    },
    {
      header: `${t("taxSummary.tables.totalPerceptions")}`,
      field: "importe",
      key: "importe",
      style: { width: "25%" },
      alignCol: "right",
      body: (rowData: PeriodoGetModelo111DtoProps) =>
        formatCurrency(rowData?.totalPercepcion ?? 0),
      bodyClassName: "!tw-w-auto !tw-text-end",
    },
    {
      header: `${t("taxSummary.tables.totalRetention")}`,
      field: "importe",
      key: "importe",
      style: { width: "25%" },
      alignCol: "right",
      bodyClassName: "!tw-w-auto tw-flex tw-justify-end",
      body: (rowData: PeriodoGetModelo111DtoProps) => {
        const isRedirect = rowData?.periodo
        return (
          <span
            className={isRedirect ? "!tw-text-info hover:tw-underline" : ""}
            onClick={() =>
              isRedirect &&
              navigate({
                route: `${ROUTES.RESUMEN_IMPUESTOS}/${MODELO_IMPUESTO.MODELO_111}`,
                periodo: rowData?.periodo,
                modelo: MODELO_IMPUESTO.MODELO_111,
                year: selectedYear,
              })
            }
          >
            {formatCurrency(rowData?.totalRetencion ?? 0)}
          </span>
        )
      },
    },
  ]

  return columns
}
